module.exports = __webpack_public_path__ + "static/media/yc_logo.e085937b.png";